<template>
  <hm-col :id="$attrs['id']" :grid="true" cols="12">
    <hm-input-date v-model="value.businessDate" :label="$t('folios.transactionEditor.businessDate')" name="businessDate" />
    <hm-input-select v-model="value.code"
                     :label="$t('folios.transactionEditor.transactionCode')"
                     :has-warning="showCodeWarning"
                     :help="codeWarningMessage"
                     name="transactionCode">
      <option :value="null" :disabled="true"></option>
      <optgroup v-for="group in options" :label="group.group">
        <option v-for="item in group.options" :value="item" v-html="item.localName"></option>
      </optgroup>
    </hm-input-select>
    <template v-if="!isNil(value.code) && !isNil(value.code.id) && value.code.type !== 'RatePlan'">
      <hm-input-toggle v-model="editItemAmount"
                       :label="$t('folios.transactionEditor.editItemAmount')"
                       :enabled-title="$t('folios.transactionEditor.editItemAmountLabel')"
                       :disabled-title="$t('folios.transactionEditor.editTotalAmountLabel')"
                       name="editItemAmount" />
      <hm-input-number v-model="value.realItemCount" :label="$t('folios.transactionEditor.itemCount')" name="itemCount" cols="12 4@tablet" />
      <hm-input-money v-model="value.itemAmount"
                      :currency="hotelSettings.details.currency"
                      :disabled="!editItemAmount"
                      :label="$t('folios.transactionEditor.itemAmount')"
                      name="itemAmount"
                      cols="12 4@tablet" />
      <hm-input-money v-model="value.amount"
                      :currency="hotelSettings.details.currency"
                      :disabled="editItemAmount"
                      :label="$t('folios.transactionEditor.amount')"
                      name="amount"
                      cols="12 4@tablet" />
      <hm-input-number v-model="value.ratePlanNumberOfNights" :label="$t('folios.transactionEditor.ratePlanNumberOfNights')" :max-fraction-digits="0" name="label" />
      <hm-input v-model="value.label" :label="$t('folios.transactionEditor.label')" name="label" />
      <hm-input v-model="value.comment" :label="$t('folios.transactionEditor.description')" name="description" />
      <template v-if="showVoucherNumber">
        <hm-input v-model="value.transactionReferenceNumber" :label="$t('folios.transactionEditor.voucherNumber')" name="transactionReferenceNumber" />
      </template>
      <template v-if="!showVoucherNumber && value.code.type === 'InHouseService'">
        <hm-input-toggle v-model="value.takeAway"
                         :label="$t('folios.transactionEditor.takeAway')"
                         :enabled-title="$t('folios.transactionEditor.takeAwayEnabled')"
                         :disabled-title="$t('folios.transactionEditor.takeAwayDisabled')"
                         :help="$t('folios.transactionEditor.takeAway_help')"
                         name="takeAway" />
        <hm-input-toggle v-if="value.amount < 0"
                         v-model="value.discountTransaction"
                         :label="$t('folios.transactionEditor.discountTransaction')"
                         :enabled-title="$t('folios.transactionEditor.discountTransactionEnabled')"
                         :disabled-title="$t('folios.transactionEditor.discountTransactionDisabled')"
                         :help="$t('folios.transactionEditor.discountTransaction_help')"
                         name="discountTransaction" />
      </template>
    </template>
    <template v-if="!isNil(value.code) && !isNil(value.code.id) && value.code.type === 'RatePlan'">
      <hm-input-number v-model="value.ratePlanNumberOfNights" :label="$t('folios.transactionEditor.ratePlanNumberOfNights')" name="ratePlanNumberOfNights" cols="12 4@tablet" />
      <!-- editItemAmount -->
      <hm-input-money v-model="value.itemAmount"
                      :currency="hotelSettings.details.currency"
                      :disabled="!editItemAmount"
                      :label="$t('folios.transactionEditor.itemAmount')"
                      name="itemAmount"
                      cols="12 4@tablet" />
      <hm-input-money v-model="value.amount"
                      :currency="hotelSettings.details.currency"
                      :disabled="editItemAmount"
                      :label="$t('folios.transactionEditor.amount')"
                      name="amount"
                      cols="12 4@tablet" />
      <hm-input v-model="value.label" :label="$t('folios.transactionEditor.label')" name="label" />
      <hm-input v-model="value.comment" :label="$t('folios.transactionEditor.description')" name="description" />
    </template>
    <template v-if="!isNil(value.code) && !isNil(value.code.id) && value.code.type === 'RatePlan'">
      <hm-input-toggle v-model="value.firstDateOfRatePlan"
                       :label="$t('folios.transactionEditor.firstDateOfRatePlan')"
                       :enabled-title="$t('folios.transactionEditor.firstDateOfRatePlanEnabled')"
                       :disabled-title="$t('folios.transactionEditor.firstDateOfRatePlanDisabled')"
                       :help="$t('folios.transactionEditor.firstDateOfRatePlan_help')"
                       name="firstDateOfRatePlan" />
      <hm-input-select v-model="value.calculationDetails.numAdults" :label="$t('folios.transactionEditor.numAdults')" name="numAdults" cols="12@mobile 6@tablet">
        <option v-for="item in intArray(100)" :value="item" v-html="item"></option>
      </hm-input-select>
      <hm-input-select v-if="hasLicense('ChildRates')"
                       v-model="value.calculationDetails.numChildren"
                       :label="$t('folios.transactionEditor.numChildren')"
                       name="numChildren"
                       cols="12@mobile 6@tablet"
                       @input="onUpdateNumChildren()"
                       @change="onUpdateNumChildren()">
        <option v-for="item in intArray(100)" :value="item" v-html="item"></option>
      </hm-input-select>
      <hm-input-select v-for="child in intArray(value.calculationDetails.numChildren)"
                       v-model="value.calculationDetails.childAgeCategories[child+1]"
                       :label="$tc('folios.transactionEditor.child', child, { count: child+1 })"
                       :key="child"
                       :required="true"
                       name="childAge"
                       cols="12@mobile 6@tablet">
        <option v-for="item in hotelSettings.ageCategories.all(value.calculationDetails.childAgeCategories[child+1])" v-if="item.ageQualifier === 'Adult'" :value="item.id" v-html="`${item.name[$shortLocale]}`"></option>
        <option v-for="item in hotelSettings.ageCategories.all(value.calculationDetails.childAgeCategories[child+1])" v-if="item.ageQualifier !== 'Adult'" :value="item.id" v-html="`${item.name[$shortLocale]} (${item.ageFrom} - ${item.ageUntil})`"></option>
      </hm-input-select>
      <hm-input-number v-model="value.calculationDetails.numCityTaxOverrides"
                       :label="$t('folios.transactionEditor.numCityTaxOverrides')"
                       :help="$t('folios.transactionEditor.numCityTaxOverrides_help')"
                       name="numCityTaxOverrides"
                       cols="12" />
      <hm-input-select v-model="value.calculationDetails.roomTypeId" :label="$t('folios.transactionEditor.roomType')" name="roomType">
        <option :value="null"></option>
        <option v-for="item in hotelSettings.roomTypes.all(value.calculationDetails.roomTypeId)" :value="item.id" v-html="item.name[$shortLocale]"></option>
      </hm-input-select>
      <hm-input-select v-model="value.calculationDetails.roomNumber" :label="$t('folios.transactionEditor.roomNumber')" name="roomNumber">
        <option :value="null"></option>
        <option v-for="item in hotelSettings.rooms.all(value.calculationDetails.roomNumber)" :value="item.roomNumber" v-html="`${item.roomNumber} (${item.roomType.name[$shortLocale]})`"></option>
      </hm-input-select>
    </template>
  </hm-col>
</template>


<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import {
  isArray,
  join,
  isNil,
  isEmpty,
  groupBy,
  values,
  head,
  cloneDeep,
  concat,
  unionBy,
  reverse,
  sortBy,
  last,
  isNumber,
  toNumber,
  get,
  first,
  filter,
} from 'lodash';
import uuid from 'uuid';
import NotificationMixin from '../../../mixins/NotificationMixin';
import FilterMixin from '../../../mixins/FilterMixin';
import HmInput from '../inputs/HmInput';
import HmInputDate from '../inputs/HmInputDate';
import HmInputMoney from '../inputs/HmInputMoney';
import HmInputToggle from '../inputs/HmInputToggle';

export default {
  name: 'TransactionEditor',
  components: { HmInputToggle, HmInputMoney, HmInputDate, HmInput },
  mixins: [HotelmeisterMixin, NotificationMixin, FilterMixin],

  props: {
    transaction: {
      type: Object,
      required: false,
      default: null,
    },
    reservation: {
      type: Object,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      editItemAmount: true,
      value: {
        id: uuid.v4(),
        businessDate: this.$moment().format('YYYYMMDD'),
        code: null,
        label: null,
        comment: null,
        itemCount: 1,
        realItemCount: 1,
        itemAmount: 0,
        amount: 0,
        chargePeriod: null,
        firstDateOfRatePlan: false,
        ratePlanNumberOfNights: 1,
        takeAway: null,
        discountTransaction: null,
        transactionReferenceNumber: null,
        calculationDetails: {
          numAdults: 0,
          numChildren: 0,
          childAgeCategories: { },
          roomNumber: null,
          roomTypeId: null,
          numCityTaxOverrides: null,
        },
      },
    };
  },

  computed: {
    options: function () {
      return [
        {
          group: this.$t('folio.transactionGroup.RatePlan'),
          options: sortBy(this.hotelSettings.ratePlans.all(isNil(this.value.code) ? null : this.value.code.id).map(it => ({ id: it.id, localName: it.name[this.$shortLocale], name: it.name, type: 'RatePlan' })), it => it.localName),
        },
        ...sortBy(
          Object.entries(groupBy(this.hotelSettings.inHouseServices.all(isNil(this.value.code) ? null : this.value.code.id), it => it.type))
            .map(it => ({
              group: this.$t(`InHouseServiceType.${it[0]}`),
              options: sortBy(it[1].map(ihs => ({ id: ihs.id, localName: ihs.name[this.$shortLocale], name: ihs.name, type: 'InHouseService' })), ihs => ihs.localName),
            })),
          it => it.group,
        ),
        {
          group: this.$t('folio.transactionGroup.Tax'),
          options: sortBy(this.hotelSettings.taxes.all(isNil(this.value.code) ? null : this.value.code.id).filter(it => it.taxType !== 'VAT').map(it => ({ id: it.id, localName: it.name[this.$shortLocale], name: it.name, type: 'Tax' })), it => it.localName),
        },
        {
          group: this.$t('folio.transactionGroup.MealPlan'),
          options: sortBy(this.hotelSettings.mealPlans.all(isNil(this.value.code) ? null : this.value.code.id).map(it => ({ id: it.id, localName: it.name[this.$shortLocale], name: it.name, type: 'MealPlan' })), it => it.localName),
        },
      ];
    },
    fixedAmount: function () {
      if (isNil(this.value.code) || isNil(this.value.code.id)) return 0;

      if (this.value.code.type === 'Tax') {
        const obj = this.findHotelSettingById('taxes', this.value.code.id);
        return isNil(obj) || obj.percentage !== false ? 0 : obj.amount;
      } else if (this.value.code.type === 'MealPlan') {
        const obj = this.findHotelSettingById('mealPlans', this.value.code.id);
        return isNil(obj) || obj.percentage !== false ? 0 : obj.amount;
      } else if (this.value.code.type === 'InHouseService') {
        const obj = this.findHotelSettingById('inHouseServices', this.value.code.id);
        return isNil(obj) ? 0 : obj.amount;
      } else {
        return 0;
      }
    },
    showVoucherNumber: function () {
      const code = this.value.code;
      if (!isNil(code) && code.type === 'InHouseService') {
        const ihs = this.findHotelSettingById('inHouseServices', code.id);

        switch (ihs.fiscalizationChargeType) {
          case 'VoucherSale':
          case 'VoucherRedeem':
          case 'CouponSale':
          case 'CouponRedeem':
            return true;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    showCodeWarning() {
      if (!isNil(this.value) && !isNil(this.value.code) && this.value.code.type === 'InHouseService') {
        const ihs = this.findHotelSettingById('inHouseServices', this.value.code.id);
        if (!isNil(ihs) && ihs.type === 'PrePayment') {
          return true;
        }
      }
      return false;
    },
    codeWarningMessage() {
      if (this.showCodeWarning) {
        return this.$t('folios.transactionEditor.warningPrePaymentTransactionCode');
      }
      return null;
    },
  },

  watch: {
    reservation: {
      handler: function () {
        if (!isNil(this.reservation)) {
          this.value.calculationDetails.numAdults = this.reservation.stayDetails.numAdults;
          this.value.calculationDetails.numChildren = this.reservation.stayDetails.numChildren;
          this.value.calculationDetails.childAgeCategories = cloneDeep(this.reservation.stayDetails.childAgeCategories);
          this.value.calculationDetails.roomNumber = this.reservation.stayDetails.roomNumber;
          this.value.calculationDetails.roomTypeId = this.reservation.stayDetails.roomTypeId;
        }
      },
      deep: true,
    },
    'value.itemAmount': function () {
      if (this.editItemAmount) this.updateTransactionAmount();
    },
    'value.amount': function () {
      if (!this.editItemAmount) this.updateItemAmount();
    },
    'value.ratePlanNumberOfNights': function () {
      if (this.editItemAmount) this.updateTransactionAmount();
      else this.updateItemAmount();
    },
    'value.realItemCount': function () {
      if (this.editItemAmount) this.updateTransactionAmount();
      else this.updateItemAmount();
    },
    'value.itemCount': function () {
      if (this.editItemAmount) this.updateTransactionAmount();
      else this.updateItemAmount();
    },
    'value.code.id': function (newVal, oldVal) {
      if (this.value.code.type !== 'RatePlan' && !isNil(newVal)) {
        if (isNil(this.transaction) || !isNil(oldVal)) {
          this.value.itemAmount = this.fixedAmount;
          this.value.amount = this.fixedAmount;
          this.value.itemCount = 1;
        }
      }
      if (!isNil(oldVal) || isEmpty(this.value.label)) {
        this.value.label = this.value.code.name[this.hotelSettings.details.primaryLanguage] || this.value.code.localName;
      }
    },
    'value.code.type': function (newVal, oldVal) {
      if (isNil(newVal) || !isNil(oldVal)) {
        this.value.ratePlanNumberOfNights = 1;
        this.value.firstDateOfRatePlan = false;
      }

      if (!isNil(this.reservation) && newVal === 'RatePlan' && newVal !== oldVal && isNil(this.transaction)) {
        this.value.businessDate = this.reservation.checkInDate;
        this.value.ratePlanNumberOfNights = Math.max(1, this.$moment(this.reservation.checkOutDate, 'YYYYMMDD').diff(this.$moment(this.reservation.checkInDate, 'YYYYMMDD'), 'days'));
      }

      /* set first date of rate plan = true if it's a newly added transaction (this.transaction IS NULL) and the
         business date equals the checkInDate (if it's linked to reservation) - this is to ensure that per-stay package elements
         are less likely to be forgotten */
      if (!isNil(this.reservation) && newVal === 'RatePlan' && newVal !== oldVal && this.value.businessDate === this.reservation.checkInDate && isNil(this.transaction)) {
        this.value.firstDateOfRatePlan = true;
      }
    },
  },

  created: function () {
    if (!isNil(this.transaction)) {
      const tmp = cloneDeep(this.transaction);
      tmp.code = this.options.flatMap(it => it.options).find(it => it.id === tmp.code.id);
      if (tmp.code.type === 'RatePlan') {
        tmp.itemAmount = tmp.amount / Math.max(tmp.ratePlanNumberOfNights, 1);
      } else {
        tmp.realItemCount = tmp.itemCount / Math.max(tmp.ratePlanNumberOfNights, 1);
        tmp.itemAmount = tmp.amount / Math.max(tmp.itemCount, 1);
      }
      this.value = tmp;
    } else {
      this.reInitTransaction();
    }
  },

  methods: {
    onUpdateNumChildren: function () {
      const children = this.intArray(this.value.calculationDetails.numChildren, 1);
      const defaultAgeCategoryId = isNil(this.hotelSettings.ageCategories.all().find(it => it.ageQualifier !== 'Adult'))
        ? this.hotelSettings.ageCategories.all().find(it => it.ageQualifier === 'Adult').id
        : this.hotelSettings.ageCategories.all().find(it => it.ageQualifier !== 'Adult').id;
      children.forEach((it) => {
        if (isEmpty(get(this.value.calculationDetails.childAgeCategories, it, null))) {
          this.value.calculationDetails.childAgeCategories[it] = defaultAgeCategoryId;
        }
      });
    },
    updateTransactionAmount() {
      if (!isNumber(this.value.itemAmount)) {
        this.value.amount = 0;
      } else if (!isEmpty(this.value.ratePlanNumberOfNights) && toNumber(this.value.ratePlanNumberOfNights) === 0) {
        this.value.amount = 0;
      } else if (!isEmpty(this.value.realItemCount) && toNumber(this.value.realItemCount) === 0) {
        this.value.amount = 0;
      } else {
        let numberOfNights = toNumber(this.value.ratePlanNumberOfNights);
        if (numberOfNights === 0) {
          numberOfNights = 1;
        }
        if (this.value.code.type === 'RatePlan') {
          this.value.amount = toNumber(this.value.itemAmount) * numberOfNights;
        } else {
          if (isNil(this.value.realItemCount)) this.value.realItemCount = this.value.itemCount;
          this.value.itemCount = this.value.realItemCount * numberOfNights;
          this.value.amount = toNumber(this.value.itemAmount) * this.value.itemCount;
        }
      }
    },
    updateItemAmount() {
      if (!isNumber(this.value.amount)) {
        this.value.itemAmount = 0;
      } else if (!isEmpty(this.value.ratePlanNumberOfNights) && toNumber(this.value.ratePlanNumberOfNights) === 0) {
        this.value.itemAmount = 0;
      } else if (!isEmpty(this.value.realItemCount) && toNumber(this.value.realItemCount) === 0) {
        this.value.itemAmount = 0;
      } else {
        let numberOfNights = toNumber(this.value.ratePlanNumberOfNights);
        if (numberOfNights === 0) {
          numberOfNights = 1;
        }
        if (this.value.code.type === 'RatePlan') {
          this.value.itemAmount = Math.round(toNumber(this.value.amount) / numberOfNights * 100) / 100;
        } else {
          if (isNil(this.value.realItemCount)) this.value.realItemCount = this.value.itemCount;
          this.value.itemCount = this.value.realItemCount * numberOfNights;
          this.value.itemAmount = Math.round(toNumber(this.value.amount) / (this.value.itemCount) * 100) / 100;
        }
      }
    },
    reInitTransaction() {
      this.value = {
        id: uuid.v4(),
        businessDate: this.$moment().format('YYYYMMDD'),
        code: null,
        label: null,
        comment: null,
        itemCount: 1,
        realItemCount: 1,
        itemAmount: 0,
        amount: 0,
        chargePeriod: null,
        firstDateOfRatePlan: false,
        ratePlanNumberOfNights: 1,
        takeAway: null,
        discountTransaction: null,
        transactionReferenceNumber: null,
        calculationDetails: {
          numAdults: 0,
          numChildren: 0,
          childAgeCategories: { },
          roomNumber: null,
          roomTypeId: null,
          numCityTaxOverrides: null,
        },
      };


      if (!isNil(this.reservation)) {
        this.value.calculationDetails.numAdults = this.reservation.stayDetails.numAdults;
        this.value.calculationDetails.numChildren = this.reservation.stayDetails.numChildren;
        this.value.calculationDetails.childAgeCategories = this.reservation.stayDetails.childAgeCategories;
        this.value.calculationDetails.roomNumber = this.reservation.stayDetails.roomNumber;
        this.value.calculationDetails.roomTypeId = this.reservation.stayDetails.roomTypeId;
      }
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';
</style>



// WEBPACK FOOTER //
// src/components/lib/folios/TransactionEditor.vue